export default __webpack_public_path__ + "98fdac1db8e95c9c14f431fb7116fce5.png";